module.exports = __webpack_public_path__ + "static/img/5.ac5d897.png";